import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Layout } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import OwnerPensionerHeaderLayout from './HeaderLayout/OwnerPensionerHeaderLayout';
import { useHandleResize } from '../../utils/handleResize';

const { Content, Footer } = Layout;

const StyledLayout = styled.div`
  height: 100vh;
  height: 100dvh;
`;

const StyledContent = styled.div`
  margin: 72px 0 0 0;
  min-height: calc(100vh - 72px);
  min-height: calc(100dvh - 72px);
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`;

const StyledFooter = styled.footer`
  padding: 10px 10px calc(10px + env(safe-area-inset-bottom));
  text-align: center;
  font-size: 12px;
  background-color: var(--bodyBackground);
  color: var(--dimGray);

  a {
    color: var(--ds-cambridge-dark);
  }
`;

export const OwnerPensionerLayout = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(globalThis.innerWidth < 992);
  const { width, height } = useHandleResize();
  const [collapseWidth, setCollapseWidth] = useState(
    globalThis.innerWidth < 576 ? 0 : 80
  );

  useEffect(() => {
    if (width < 576) {
      setCollapseWidth(0);
    } else {
      setCollapseWidth(80);
    }
  }, [width, height]);

  useEffect(() => {
    document
      .getElementById('mainContent')
      .scrollTo({ behavior: 'smooth', top: 0 });
  }, [location]);

  return (
    <StyledLayout as={Layout}>
      <Layout>
        <OwnerPensionerHeaderLayout
          collapsed={collapsed}
          collapseSider={setCollapsed}
          collapseWidth={collapseWidth}
        />
        <StyledContent as={Content} id="mainContent">
          <Outlet />
          <StyledFooter as={Footer}>
            {`${t('global.title')} ©${dayjs().year()} powered by `}
            <a href="https://strateg.in">Strateg.in</a>
          </StyledFooter>
        </StyledContent>
      </Layout>
    </StyledLayout>
  );
};
